import { Directive, ElementRef, HostBinding, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonVariants, DsModalColorVariant } from '@levelaccess/design-system';

import { PageFormComponent, IPageFormConfig } from '../../../../components/page-form/page-form.component';
import { ErrorMessageService } from '../../../../services/error-message.service';

export enum PageModalType {
  ADD = 'ADD',
  EDIT = 'EDIT',
}

@Directive()
export abstract class AbstractPageModalComponent implements OnDestroy {
  @ViewChild(PageFormComponent)
  public pageFormComponent: PageFormComponent;

  public backNavLabel: string | undefined;

  public readonly DsModalColorVariant: typeof DsModalColorVariant = DsModalColorVariant;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  protected subscription: Subscription = new Subscription();

  public abstract readonly modalType: PageModalType;
  public abstract submit(): void;

  public bannerText: string | undefined;
  public formConfig: IPageFormConfig;
  public existingUrls: string[];
  public existingNames: string[];
  public domainRestrictions: RegExp[];

  @Input() showUrl: boolean = true;

  private _width?: string;

  @Input()
  set width(value: string | undefined) {
    this._width = value;
  }

  get width(): string | undefined {
    return this._width;
  }

  @HostBinding('style.width')
  get hostWidth(): string | null {
    return this._width || null;
  }

  @HostBinding('style.maxWidth')
  get hostMaxWidth(): string | null {
    return this._width ? '100%' : null;
  }

  protected constructor(
    public modal: NgbActiveOffcanvas,
    protected element: ElementRef<Element>,
    protected errorMessageService: ErrorMessageService,
  ) {}

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public cancel(): void {
    this.modal.dismiss();
  }

  public get pageTitle(): string {
    return this.modalType === PageModalType.ADD ? 'add_page' : 'edit_page';
  }

  public get submitButtonLabel(): string {
    return this.modalType === PageModalType.ADD ? 'add_page' : 'edit_page';
  }
}
